import * as commandeTlpe from '@/i18n/fr/gabed/commandeTlpe/commandeTlpe';
import * as emplacement from './emplacement/emplacement';
import * as dispositif from './dispositif/dispositif';
import * as materiel from './materiel/materiel';
import * as face from './face/face';
import * as collectivite from './collectivite/collectivite';
import * as titreRecette from './titreRecette/titreRecette';
import LISTE_PAIEMENT_FACTURE_ACHAT from '../achat/paiement/paiement';
import PATRIMOINE from './patrimoine/patrimoine';

const GABED = {
  emplacement: emplacement.EMPLACEMENT,
  detailEmplacement: emplacement.DETAIL_EMPLACEMENT,
  adresseEmplacement: emplacement.ADRESSE_EMPLACEMENT,
  clientEmplacement: emplacement.CLIENT_EMPLACEMENT,
  parkingEmplacement: emplacement.PARKING_EMPLACEMENT,
  centreCommercialEmplacement: emplacement.CENTRE_COMMERCIAL_EMPLACEMENT,
  ligneBusEmplacement: emplacement.LIGNE_BUS_EMPLACEMENT,
  dispositifPublicitaire: dispositif.DISPOSITIF_PUBLICITAIRE,
  detailDispositif: dispositif.DETAIL_DISPOSITIF,
  materiel: materiel.MATERIEL,
  patrimoine: PATRIMOINE,
  face: face.FACE,
  faceByBailleur: face.FACE_BY_BAILLEUR,
  detailFace: face.DETAIL_FACE,
  listeFace: face.LISTE_FACE,
  listeMateriel: materiel.LISTE_MATERIEL,
  listeMaterielTlpe: materiel.LISTE_MATERIEL_TLPE,
  listeDispositif: dispositif.LISTE_DISPOSITIF,
  editionCollectivite: collectivite.AJOUT_EDITION_COLLECTIVITE,
  listeCollectivite: collectivite.LISTE_COLLECTIVITE,
  detailCollectivite: collectivite.DETAIL_COLLECTIVITE,
  archiverCollectivite: collectivite.ARCHIVER_COLLECTIVITE,
  detailMateriel: materiel.DETAIL_MATERIEL,
  emplacementDispositifMaterielFacePicker: emplacement.EMPLACEMENT_DISPO_MATERIEL_FACE_PICKER,
  remplacementFace: face.REMPLACEMENT_PRODUIT_FACE,
  declarationTlpe: collectivite.DECLARATION_TLPE,
  listeCommandeTlpe: commandeTlpe.LISTE_COMMANDE_TLPE,
  editCommandeTlpe: commandeTlpe.EDIT_COMMANDE_TLPE,
  detailCommandeTlpe: commandeTlpe.DETAIL_COMMANDE_TLPE,
  editionTitreRecette: titreRecette.TITRE_RECETTE_EDITION,
  detailTitreRecette: titreRecette.DETAIL_TITRE_RECETTE,
  listeTitreRecette: titreRecette.LISTE_TITRE_RECETTE,
  listePaiementFactureAchat: LISTE_PAIEMENT_FACTURE_ACHAT,
};

export default GABED;
